import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import i18n from 'i18next'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createForgotPassword({
  locale,
  parentId,
  masterBlockId,
}: {
  parentId: string
  masterBlockId?: MasterBlockId
  locale: string
}): CustomLoginForgotPasswordInterface {
  const fixedT = i18n.getFixedT(locale)
  const forgotPasswordString = fixedT(
    'entities.member_access.request.default_headline',
  )
  return {
    id: generateId(),
    type: EntityTypeEnum.CustomLoginForgotPassword,
    parentId,
    masterBlockId,
    fontSize: 16,
    mobileFontSize: 16,
    text: forgotPasswordString,
    color: 'rgba(0, 160, 225, 100)',
    mobileColor: 'rgba(0, 160, 225, 100)',
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.CustomLoginForgotPassword),
  }
}
